<page-toolbar [pageActions]="pageActions" [title]="pageTitle"></page-toolbar>

<page-content *ngIf="app">

  <mat-card appearance="outlined">
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input [(ngModel)]="app.name" matInput>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Icon</mat-label>
      <input [(ngModel)]="app.icon" matInput>
    </mat-form-field>
    <div [class]="appTranslations.size > 0 ? 'menu-container' : 'menu-container no-translations'">
      <button [matMenuTriggerFor]="languageMenu" color="primary" mat-raised-button>Add/Remove Language</button>
      <mat-menu #languageMenu="matMenu">
        <button (click)="languageChange(language.key)" *ngFor="let language of availableLanguages|mapValues" mat-menu-item>
          <mat-checkbox [(ngModel)]="language.active">{{language.key}}</mat-checkbox>
        </button>
      </mat-menu>
    </div>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-tab-group *ngIf="activatedLanguages && activatedLanguages.length" class="language-tabs-container">
      <mat-tab *ngFor="let translation of activatedLanguages" label="{{translation.translation.language}}">
        <app-composition-app-editor-menu-items [appTranslation]="translation"
                                               [availableItemsProvider]="availableItemsProvider"></app-composition-app-editor-menu-items>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
  <button (click)="saveCompositionApp()" color="primary" mat-raised-button>Save</button>
</page-content>
